import axios from 'axios';
import sjcl from 'sjcl'
var axiosInstance = axios.create({
  // baseURL: `http://10.41.0.48:5000/enmovil/`
  // baseURL: `http://4.224.24.95:5000/enmovil/`
  baseURL: `https://twt.enmovil.net/enmovil/`
  // baseURL: `http://localhost:5000/enmovil/`
});

const key='McKtSdj3uVBABcCK8kGLRNtUxXtNMOEsmUPxQwNI4uo='
// axiosInstance.interceptors.request.use(function (params) {
//   var parameters = params.data;
//   // console.log("parameters ", parameters)
//   var newparameters = {}
//   var flag = 0;
//   for(var key in parameters)
//   {
//     if(parameters[key] == "undefined" || parameters[key] == undefined)
//     {
//       newparameters[key] = "";  
//     }
//     else{
//       try{
        
//         var pm = parameters[key].toString();
//         // newparameters[key] =encode(pm);
//         newparameters[key] =pm;
        
//       }
//       catch(e){

//       }
      
//     }
//   }
//   newparameters["token"] = localStorage.getItem("token");
//   params.data=newparameters;
  
//   return params;


// axiosInstance.interceptors.request.use(
//   function(req){
//     var formdataUrls=['/dispatch/generateLoad','/dispatch/validateInputDealerCode','dispatch/dispatchplandetails',"/dispatch/generateLoadByInputData","http://216.48.191.229:8011/dispatch_planning/fetchLocationAddressDetails",
//     "/dispatch/generatePlanData","/dealers/readXLSData","/forecast/readXLSSupplierData","/forecastvehicle/saveOBDInputData","/tsp/addedNewOBDToPlannedData","/dispatch/consolidatedData"]
//     if (formdataUrls.includes(req.url) ){
//       return req
//     }else{
//       if(req.data!==undefined){
//       var params=sjcl.encrypt(key,JSON.stringify(req.data))
//       req.data={encryptedparams:params}
//       }else{
//         var params=sjcl.encrypt(key,JSON.stringify({}))
//         req.data={encryptedparams:params}
//       }
//       return req
//     }
//   },function(error){
//     return Promise.reject(error)
//   }
// )

axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log('Response data:', response.data);
    if(response.data.encrypted_res !== undefined){
      var output=sjcl.decrypt(key,response.data.encrypted_res)
      response.data=JSON.parse(output) 
    }
    // console.log(response.data,'helo')
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.error('Response interceptor error:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
